import { useState } from "react";

export interface MultiselectOption {
  label: string;
  value: string;
  dataverseValue: string;
}

export interface MultiselectOptionsProps {
  options: MultiselectOption[];
  formFieldName: string;
  isRequired?: boolean;
}

export function MultiselectOptions({
  options,
  formFieldName,
  isRequired,
}: MultiselectOptionsProps) {
  const [selected, setSelected] = useState<Set<string>>(new Set());

  const toggleValue = (val: string) => {
    const newSet = new Set(selected);
    if (newSet.has(val)) {
      newSet.delete(val);
    } else {
      newSet.add(val);
    }
    setSelected(newSet);
  };

  return (
    <>
      {isRequired && (
        <input
          type="text"
          tabIndex={-1}
          autoComplete="off"
          className="h-0 w-0 opacity-0"
          required
          value={selected.size > 0 ? "valid" : ""}
          onChange={() => {}}
          id="validation-input"
        />
      )}
      {options.map(({ label, value }, index) => (
        <label key={value} className="flex items-center gap-2" htmlFor={value}>
          <input
            type="checkbox"
            name={formFieldName}
            id={value}
            value={value}
            className="mr-3 border border-solid border-black"
            onChange={() => toggleValue(value)}
          />
          {label}
        </label>
      ))}
    </>
  );
}
